export default __webpack_public_path__ + "static/media/GridInactive.442f6570.svg";